import { createStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { handleSubscribers as t } from "@magnopus-opensource/connected-spaces-platform-web-api";
var n = e((e) => ({
	selectingOverridePath: !1,
	setSelectingOverridePath: (t) => {
		e(() => ({ selectingOverridePath: t }));
	}
}));
t(n);
//#endregion
export { n as setNewMaterialOverrideStore };
